export default __webpack_public_path__ + "static/media/Elpedison_ΗΛ.b94e97f2.png";